export const environment = {
    production: false,
    hmr       : false,
};
